<div class="figma-app-chrome-bg" aria-hidden="true">
  <img
    class="figma-app-chrome-bg__art"
    src="assets/images/figma/app-chrome-background.svg"
    width="1366"
    height="720"
    alt=""
  />
</div>
<div class="figma-app-content">
  <app-figma-alert-toast [toastKey]="formAlertsToastKey" (toastClose)="onFormAlertToastClose($event)" />
  <app-form-update-loading-overlay />
  <router-outlet></router-outlet>
</div>
